import { usStates } from '../../../../../../../components/Common/StateSelect';
import { jobSubTableAccountsData, jobTypesPaper } from '../subTableConfig';

export interface GeoDeliveryRow {
  id: string;
  state: { code: string; label: string };
  totalMail: number;
  deliveredMail: number;
  scannableMail: number;
  exceptionMail: number;
}

const filteredGeoData = jobSubTableAccountsData.filter(item => jobTypesPaper.includes(item.jobType));

const sortItems = (items: GeoDeliveryRow[]): GeoDeliveryRow[] =>
  items.sort((a, b) => {
    // If both items have a positive `totalMail`, sort them by `totalMail`
    // if (a.totalMail > 0 && b.totalMail > 0) { return a.totalMail - b.totalMail; }

    // If only one of the items has a positive `totalMail`, prioritize it
    if (a.totalMail > 0) {
      return -1;
    }
    if (b.totalMail > 0) {
      return 1;
    }

    // If both items have `totalMail` equal to 0, preserve their order
    return 0;
  });

export const geoDeliveryData: GeoDeliveryRow[] = sortItems(
  usStates.map(state => {
    const currStateItems = filteredGeoData.filter(item => item.state === state.value);

    const deliveredMail = currStateItems.filter(item => item.delivery === 'Delivered Mail').length;
    const scannableMail = currStateItems.filter(item => item.delivery === 'Scannable Mail').length;
    const exceptionMail = currStateItems.filter(item => item.delivery === 'Exception Mail').length;

    return {
      id: state.value,
      state: { code: state.value, label: `${state.label} (${state.value.toUpperCase()})` },
      totalMail: deliveredMail + scannableMail + exceptionMail,
      deliveredMail,
      scannableMail,
      exceptionMail,
    };
  }),
);
